<div class="payment-detail-drawer">
  <!-- ════ HEADER BAR ════ -->
  <div class="drawer-header">
    <div class="header-left">
      <span class="header-badge">
        <i class="fas fa-receipt"></i> Recibo de Pagamento
      </span>
      <h2 class="drawer-title">Transação #{{ pagamento?.referenciaPagamento || 'Detalhes' }}</h2>
    </div>

    <div class="drawer-header-actions">
      <!-- Botão de Exportar Comprovativo -->
      <button *ngIf="pagamento?.campanha?.estadoCampanhaENUM === 6 && !loading" type="button" class="btn-export-receipt"
        (click)="exportarComprovativoDoacaoFundo(pagamento)" title="Descarregar Comprovativo Oficial">
        <i class="fas fa-file-pdf"></i>
        <span>Comprovativo</span>
      </button>

      <p-progress-spinner strokeWidth="3" fill="transparent" animationDuration=".5s"
        [style]="{ width: '24px', height: '24px' }" *ngIf="loading" />

      <button type="button" class="btn-close-drawer" (click)="closeDetalhe()" title="Fechar">
        <i class="fas fa-xmark"></i>
      </button>
    </div>
  </div>

  <div class="drawer-body">
    <!-- ════ RECEIPT AMOUNT HIGHLIGHT ════ -->
    <div class="receipt-highlight-card">
      <div class="receipt-top">
        <span class="receipt-lbl">Montante Total Liquidado</span>
        <span class="receipt-status-pill" [attr.data-status]="pagamento?.estadoApoio">
          <i class="fas fa-circle-check" *ngIf="pagamento?.estadoApoio === 'Confirmado'"></i>
          <i class="fas fa-clock" *ngIf="pagamento?.estadoApoio === 'Pendente'"></i>
          <i class="fas fa-circle-xmark" *ngIf="pagamento?.estadoApoio === 'Cancelado'"></i>
          {{ pagamento?.estadoApoio || 'Processado' }}
        </span>
      </div>

      <div class="receipt-amount">
        <span class="currency">AOA</span>
        <span class="val">{{ ((pagamento?.valorDoadoTotal ?? pagamento?.valorApoio) || 0) | money }}</span>
      </div>

      <div class="receipt-reference-row">
        <span class="ref-label">Referência / ID:</span>
        <strong class="ref-code">{{ pagamento?.referenciaPagamento || 'Não Informado' }}</strong>
      </div>
    </div>

    <!-- ════ DETAILS TILES ════ -->
    <div class="section-card">
      <h4 class="section-title">
        <i class="fas fa-circle-info text-primary"></i> Informações da Operação
      </h4>

      <div class="info-tiles-grid">
        <!-- Campanha -->
        <div class="info-tile col-span-2">
          <div class="tile-icon campaign">
            <i class="fas fa-bullhorn"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Campanha Apoiada</span>
            <strong class="tile-value">{{ pagamento?.campanha?.titulo || "Não Informado" }}</strong>
          </div>
        </div>

        <!-- Doador -->
        <div class="info-tile">
          <div class="tile-icon user">
            <i class="fas fa-user-heart"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Nome do Doador</span>
            <strong class="tile-value">{{ pagamento?.utilizadorNome || "Anónimo" }}</strong>
          </div>
        </div>

        <!-- Método de Pagamento -->
        <div class="info-tile">
          <div class="tile-icon method">
            <i class="fas fa-credit-card"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Método de Pagamento</span>
            <strong class="tile-value">{{ pagamento?.metodoPagamento || "Multicaixa Express" }}</strong>
          </div>
        </div>

        <!-- Sector -->
        <div class="info-tile">
          <div class="tile-icon sector">
            <i class="fas fa-tag"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Sector / Categoria</span>
            <strong class="tile-value">{{ pagamento?.campanha?.categoria?.descricao || "Não Informado" }}</strong>
          </div>
        </div>

        <!-- Data do Pagamento -->
        <div class="info-tile">
          <div class="tile-icon date">
            <i class="fas fa-calendar-days"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Data e Hora</span>
            <strong class="tile-value">{{ pagamento?.dataCriacaoFormatada || "Pendente" }}</strong>
          </div>
        </div>

        <!-- Tipo de Financiamento -->
        <div class="info-tile">
          <div class="tile-icon finance">
            <i class="fas fa-hand-holding-dollar"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Tipo de Financiamento</span>
            <strong class="tile-value">{{ pagamento?.campanha?.tipoFinanciamento || "Doação" }}</strong>
          </div>
        </div>

        <!-- Responsável da transação se aplicável -->
        <div class="info-tile" *ngIf="pagamento?.metodoApoioENUM === 2">
          <div class="tile-icon admin">
            <i class="fas fa-user-shield"></i>
          </div>
          <div class="tile-content">
            <span class="tile-label">Autorizado Por</span>
            <strong class="tile-value">{{ pagamento?.utilizadorResponsavelTransacaoNome || "Sistema" }}</strong>
          </div>
        </div>
      </div>
    </div>

    <!-- ════ FINANCIAL BREAKDOWN TABLE ════ -->
    <div class="section-card">
      <h4 class="section-title">
        <i class="fas fa-file-invoice-dollar text-primary"></i> Repartição Financeira
      </h4>

      <div class="breakdown-card">
        <div class="breakdown-row">
          <div class="bd-item">
            <span class="bd-title">{{ pagamento?.campanha?.tipoFinanciamento || "Valor Doado à Campanha" }}</span>
            <span class="bd-sub">Quota base líquida destinada ao promotor</span>
          </div>
          <span class="bd-val font-semibold">
            AOA {{ ((pagamento?.valorDoadoCampanha ?? pagamento?.valorApoio) || 0) | money }}
          </span>
        </div>

        <div class="breakdown-row">
          <div class="bd-item">
            <span class="bd-title">Taxa de Serviço FundCube ({{ (pagamento?.taxaServico ?? taxaServico) }}%)</span>
            <span class="bd-sub">Custos de infraestrutura, processamento e suporte</span>
          </div>
          <span class="bd-val text-red-500 font-medium">
            + AOA {{ ((pagamento?.valorTaxa ?? ValorTaxa ?? 0)) | money }}
          </span>
        </div>

        <div class="breakdown-row total-row">
          <div class="bd-item">
            <span class="bd-title-total">Total Liquidado</span>
            <span class="bd-sub">Montante integral transacionado</span>
          </div>
          <span class="bd-val-total">
            AOA {{ ((pagamento?.valorDoadoTotal ?? pagamento?.valorApoio) || 0) | money }}
          </span>
        </div>
      </div>
    </div>

  </div>
</div>